import { useQueryClient } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { CreateNoteForm } from '@components/Notes/CreateForm';
import { PageTitle } from '@components/PageTitle';
import { queryKeys } from '@constants/queryKeys.constant';
import { ENoteOwnerType } from '@enums/note.enum';
import { updateInterventionCounts } from '@helpers/queryCache/updateTabCounts.helper';

export const Route = createFileRoute(
  '/_layout/(private)/service-requests/$id/interventions/$interventionId/notes/create',
)({
  component: InterventionNoteCreate,
});

function InterventionNoteCreate() {
  const { id, interventionId } = Route.useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return (
    <>
      <PageTitle
        hasBackButton
        params={{ id }}
        title="Create note"
        to="/service-requests/$id"
      />
      <CreateNoteForm
        notePayload={{
          interventionId,
          ownerType: ENoteOwnerType.Intervention,
        }}
        onCancel={() =>
          navigate({ params: { id }, to: '/service-requests/$id' })
        }
        onCreate={() =>
          updateInterventionCounts({
            delta: 1,
            field: 'notes',
            interventionId,
            queryClient,
            serviceRequestId: id,
          })
        }
        onSuccess={() =>
          navigate({
            params: { id },
            replace: true,
            to: '/service-requests/$id',
          })
        }
        queryKeyToInvalidate={queryKeys.interventions.notes(interventionId)}
      />
    </>
  );
}
